/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CloneMenuRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "menuId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "channels": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CloneMenuResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneMenuRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneMenuResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CloneMenuRequest @ squareup/connect/v2/catalog/interfaces/clone-menu.proto at 20:1
 */
export const CloneMenuRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneMenuRequest');
fixType(CloneMenuRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  menuId: {
    required: true
  }
});
Builder.createAndAttachToType(CloneMenuRequest);
/**
 * SOURCE CloneMenuResponse @ squareup/connect/v2/catalog/interfaces/clone-menu.proto at 60:1
 */
export const CloneMenuResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneMenuResponse');
fixType(CloneMenuResponse);
Builder.createAndAttachToType(CloneMenuResponse);